document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  
  accordionHeaders.forEach(header => {
    const getContent = function () {
      const item = header.closest('.accordion-item');
      if (item) return item.querySelector('.accordion-content');
      return header.nextElementSibling;
    };

    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', !isExpanded);
      
      // Toggle the accordion content visibility
      const content = getContent();
      if (content && content.classList.contains('accordion-content')) {
        content.style.display = isExpanded ? 'none' : 'block';
      }
    });
    
    // Set initial content visibility based on aria-expanded
    const content = getContent();
    if (content && content.classList.contains('accordion-content')) {
      content.style.display = header.getAttribute('aria-expanded') === 'true' ? 'block' : 'none';
    }
  });
}); 